import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {createImage, deleteImage, getImages,} from "./ActionCreators";
import {IImage, IImageState} from "./Helper";

const initialValue: IImageState = {
    fetchLoading: false,
    items: [],
    actionLoading: false,
}

const imageSlice = createSlice({
    name: SliceNames.IMAGE,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getImages.pending, (state) => {
                state.fetchLoading = true
            })
            .addCase(
                getImages.fulfilled, (state, action: PayloadAction<IImage[]>) => {
                    state.items = action.payload
                    state.fetchLoading = false
                })
            .addCase(
                getImages.rejected, (state) => {
                    state.items = []
                    state.fetchLoading = false
                })
            .addCase(
                createImage.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                createImage.fulfilled, (state, action: PayloadAction<IImage>) => {
                    state.items = [...state.items, action.payload]
                    state.actionLoading = false
                })
            .addCase(
                createImage.rejected, (state) => {
                    state.actionLoading = false
                })
            .addCase(
                deleteImage.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                deleteImage.fulfilled, (state, action: PayloadAction<string>) => {
                    state.items = [...state.items].filter((i) => i.id !== action.payload)
                    state.actionLoading = false
                })
            .addCase(
                deleteImage.rejected, (state) => {
                    state.actionLoading = false
                })
    }
})

export default imageSlice.reducer

